import { z } from 'zod';

export const QueryScheduleSchema = z.object({
  scheduledQueryId: z.string(),
  chatSessionId: z.string(),
  chatTitle: z.string().nullable(),
  scheduling: z.enum(['daily', 'weekly', 'monthly', 'quarter']),
  status: z.enum(['active', 'scheduled', 'expired']),
  startDate: z.iso.datetime({ local: true }),
  endDate: z.iso.datetime({ local: true }),
  userTimezone: z.string(),
  cronExpression: z.string(),
  query: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const CreateQueryScheduleRequestSchema = z.object({
  scheduling: z.enum(['daily', 'weekly', 'monthly', 'quarter']),
  userTimezone: z.string(),
  startDate: z.iso.datetime({ local: true }),
  endDate: z.iso.datetime({ local: true }),
  chatTitle: z.string().nullish(),
  query: z.string(),
});

export const EditQueryScheduleRequestSchema = z.object({
  scheduling: z.enum(['daily', 'weekly', 'monthly', 'quarter']),
  userTimezone: z.string(),
  startDate: z.iso.datetime({ local: true }),
  endDate: z.iso.datetime({ local: true }),
  chatTitle: z.string().nullish(),
  query: z.string().nullish(),
});
